export default "__VITE_ASSET__e7d53aed__"